import React, { useCallback, useEffect, useRef } from "react";
import { graphql, useStaticQuery } from "gatsby";
import Modal from "./modal";
import { onetrustShowSettings } from "../utility/onetrust";
import useStoreLocator from "../hooks/use-store-locator";

const WhereToBuyModal = ({ show, onHide }) => {
  const ref = useRef(null);
  const storeLocatorPage = useStoreLocator();

  useEffect(() => {
    if (show && ref.current) {
      ref.current.focus();
    }
  }, [show]);

  const closeDialog = useCallback(() => {
    if (ref.current) {
    }
    sessionStorage.setItem("cookiesClosed", true);
    onHide();

    window.location.href = storeLocatorPage;
  }, [onHide, storeLocatorPage]);

  const cookiesAcceptance = sessionStorage.getItem("cookiesClosed");

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") {
        closeDialog();
      }
    },
    [closeDialog]
  );

  const { modalData, wtbCookies } = useStaticQuery(graphql`
    {
      modalData: liferayModal(messageType: { eq: "cookie" }) {
        closeButtonLabel
        ctaLabel
        ctaLink
        ctaTarget
        description
        messageType
        title
      }
      wtbCookies: liferayGeneralConfiguration {
        wtbCookies
      }
    }
  `);

  return (
    <>
      {wtbCookies.wtbCookies?.[0] === "yes" && cookiesAcceptance !== "true" && (
        <Modal>
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
          <div
            ref={ref}
            className={`youtube-modal${show ? " youtube-modal--show" : ""}`}
            role="dialog"
            aria-hidden={!show}
            onKeyDown={onKeyDown}
          >
            <div className="youtube-modal__dialog" role="document">
              <div className="youtube-modal__alert">
                <div className="youtube-modal__alert-content youtube-modal__alert-content-wtb text-center">
                  <div className="youtube-modal__alert-title">{modalData?.title}</div>
                  <div className="d-flex flex-column flex-md-row justify-content-center align-items-center mt-3 mt-md-4">
                    <button
                      className="btn-link mb-2 mb-md-0 mr-md-3 button primary"
                      onClick={onetrustShowSettings}
                    >
                      {modalData.ctaLabel}
                    </button>
                    <button
                      className="youtube-modal__alert-close btn-link btn-link--white button tertiary"
                      onClick={closeDialog}
                    >
                      {modalData.closeButtonLabel}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default WhereToBuyModal;
